import React from 'react';

const TableHeader = ({ columns }) => {
    // console.log("TableHeader columns:", columns);
    // console.log("TableHeader columns:");
    const subCols = columns.flatMap(col => col.subColumns || [ col ]);
    const gridTemplateColumns = subCols.map(col => col.width).join(" ");

    return (


        <div className="header-grid-container" style={{ position: 'sticky', top: 0, zIndex: 1 }}>

            <div className="header-grid"
                style={{
                    display: "grid",
                    gridTemplateColumns,
                    gridTemplateRows: "50px 50px",
                    border: "1px solid #ccc",
                    overflow: "hidden",
                }}
            >
                {columns.map((col, index) =>
                    col.rowSpan === 2 ? (
                        <div key={index} style={{
                            gridRow: "1 / span 2",
                            backgroundColor: col.color,
                            color: "white",
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            border: "1px solid #ccc"
                        }}
                            className='header-cell test-header'
                        >{col.label}</div>
                    ) : (
                        <div key={index} style={{
                            gridColumn: `span ${col.subColumns.length}`,
                            gridRow: "1",
                            backgroundColor: col.color,
                            color: "white",
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            border: "1px solid #ccc"
                        }}
                            className='header-cell'
                        >{col.label}</div>
                    )
                )}
                {columns.flatMap((col) =>
                    col.subColumns?.map((sub, i) => (
                        <div key={i + Math.random(5)} className='header-cell' style={cellStyle(sub)}>{sub.label}</div>
                    )) || []
                )}
            </div>
        </div>
    );
};

const cellStyle = (col) => ({
    backgroundColor: col.color,
    color: 'white',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #ccc'
});

export default TableHeader;
